import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { LocationDateComponent } from './LocationDateComponent';
import { TitleSummary } from '../../style';

export const ActionComponent = ({ field }) => {
  return (
    <Row>
      <Col md={24} key={field.idInput}>
        <TitleSummary level={5}>{field.label}</TitleSummary>
        {field.value ? <LocationDateComponent field={field} /> : null}
      </Col>
    </Row>
  );
};

ActionComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
